import { render, staticRenderFns } from "./check.vue?vue&type=template&id=66ece218&scoped=true&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"
import style0 from "./check.vue?vue&type=style&index=0&id=66ece218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ece218",
  null
  
)

export default component.exports